export const Cash = {
  en: {
    Location: 'Location',
    Today: 'Today',
    'Record Expense': 'Record Expense',
    'Record Revenue': 'Record Revenue',
    'Cash Transfer': 'Cash Transfer',
    'Cash Register': 'Cash Register',
    Category: 'Category',
    'Business Direction': 'Business Direction',
    Operation: 'Operation',
    Operations: 'Operations',
    'Created By': 'Created By',
    Inflow: 'Inflow',
    Outflow: 'Outflow',
    'Opening Balance': 'Opening Balance',
    'Current Balance': 'Current Balance',
    "Today's Operations": "Today's Operations",
    'No operations today': 'No operations today',
    'No cash registers at this location': 'No cash registers at this location',
    'From Register': 'From Register',
    'To Register': 'To Register',
    'Amount must be greater than 0': 'Amount must be greater than 0',
    'Registers must be different': 'Registers must be different',
    'Fiscal register hint':
      'The selected register works with fiscalization — a service receipt will be created in Checkbox.',
  },
  uk: {
    Location: 'Локація',
    Today: 'Сьогодні',
    'Record Expense': 'Зафіксувати витрату',
    'Record Revenue': 'Зафіксувати надходження',
    'Cash Transfer': 'Переказ між касами',
    'Cash Register': 'Каса',
    Category: 'Категорія',
    'Business Direction': 'Напрямок діяльності',
    Operation: 'Операція',
    Operations: 'Операції',
    'Created By': 'Ким створено',
    Inflow: 'Надходження',
    Outflow: 'Витрати',
    'Opening Balance': 'Залишок на початок',
    'Current Balance': 'Поточний залишок',
    "Today's Operations": 'Операції за сьогодні',
    'No operations today': 'Сьогодні операцій немає',
    'No cash registers at this location': 'На цій локації немає кас',
    'From Register': 'З каси',
    'To Register': 'На касу',
    'Amount must be greater than 0': 'Сума має бути більшою за 0',
    'Registers must be different': 'Каси мають відрізнятися',
    'Fiscal register hint':
      'Вибрана каса працює з фіскалізацією — у Checkbox буде створено службовий чек.',
  },
};
